import { TableCell, TableRow } from "@mui/material";
import React from "react";

import { LoadingState } from "./LoadingState";

interface AdminTableLoadingRowProps {
  colSpan: number;
  label: React.ReactNode;
}

/** A consistent, accessible loading row that keeps admin table columns visible. */
export const AdminTableLoadingRow: React.FC<AdminTableLoadingRowProps> = ({ colSpan, label }) => (
  <TableRow>
    <TableCell colSpan={colSpan} align="center" sx={{ py: 5 }}>
      <LoadingState label={label} />
    </TableCell>
  </TableRow>
);
